import {lazy} from "react";
import {authRoles} from "app/auth/authRoles";

const DocumentFoldersBreadcrumb = lazy(() => import("./document-folder-root"));

const documentFoldersRoutes = [
    {
        path: "/document-folders",
        element: <DocumentFoldersBreadcrumb/>,
        auth: authRoles.admin,
    },
];

export default documentFoldersRoutes;